import { observable, toJS } from "mobx";
import React from "react";
import moment from "moment";
import MovimentacaoService from "../../../../services/MovimentacaoService";
import lscache from "lscache";
import { textFormatter, formatarDataMov, YesNoFormatter, formatarCnpj } from "../../../../utils/formatar";
import { buscaFiltrarVazio, buscaSemResultado } from '../../../../utils/mensagens';
import { sortCaret } from '../../../comum/components/Icones';

export default class MovimentacaoStore {

    @observable seletorPeriodo;
    @observable dataInicial;
    @observable dataFinal;
    @observable operacao;
    @observable listaOperacoes;
    @observable loadingOperacoes;
    @observable tipoMovimentacao;
    @observable listaTipoMovimentacao;
    @observable status;
    @observable listaStatus;
    @observable tipo;
    @observable listaTipo;
    @observable tamanho;
    @observable listaTamanho;
    @observable categoria;
    @observable listaCategoria;
    @observable armadores;
    @observable listaArmadores;
    @observable loadingArmadores
    @observable loading;
    @observable listaItens;
    @observable tableMessage;
    @observable cliente;
    @observable listaClientes;
    @observable grupos
    @observable listaGrupos
    @observable loadingClientes;
    @observable mostrarCamposExibicao
    @observable camposTabela
    @observable total
    @observable perfilUsuario
    @observable obrigatoriosPreenchidos
    @observable operacaoAtivo
    @observable periodoAtivo

    constructor() {
        this.seletorPeriodo = false;
        this.dataInicial = moment().subtract(14, 'day').format("YYYY-MM-DD");
        this.dataFinal = moment().add(0, 'day').format("YYYY-MM-DD");
        this.operacao = null;
        this.listaOperacoes = [];
        this.loadingOperacoes = false;
        this.tipoMovimentacao = null;
        this.listaTipoMovimentacao = [];
        this.status = null;
        this.listaStatus = [];
        this.tipo = null;
        this.listaTipo = [];
        this.tamanho = null;
        this.listaTamanho = [];
        this.categoria = null;
        this.listaCategoria = [];
        this.armadores = null;
        this.listaArmadores = [];
        this.cliente = null
        this.listaClientes = []
        this.grupos = null
        this.listaGrupos = []
        this.loadingGrupos = false
        this.loading = false;
        this.listaItens = [];
        this.tableMessage = buscaFiltrarVazio;
        this.mostrarCamposExibicao = false;
        this.filtrado = false;
        this.filtroSelecionado = 0
        this.total = null
        this.loadingArmadores = false
        this.loadingClientes = false
        this.perfilUsuario = lscache.get('Perfil')
        this.operacaoAtivo = true
        this.periodoAtivo = true
        this.obrigatoriosPreenchidos = {
            operacao: true,
            tipoMovimentacao: true,
            armadores: true,
            clientes: true,
            grupos: true,
            geral: true //representa se todas as condições dos filtros foram cumpridas
        }

        this.todasColunas = [{
                dataField: 'Container',
                text: 'Container',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'ArmId',
                text: 'Cod. Armador',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'Iso',
                text: 'Cod. ISO',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'Avariado',
                text: 'Avariado',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'Booking',
                text: 'Booking',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'CargaPerigosa',
                text: 'Carga Perigosa',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'Categoria',
                text: 'Categoria',
                sort: true,
                sortCaret: sortCaret,
                formatter: this.categoriaFormatter,
                align: () => 'center'
            },
            {
                dataField: 'TamContainer',
                text: 'Tam.',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },            
            {
                dataField: 'DscTipoCntr',
                text: 'Tipo de Container',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'DescTipoCntr',
                text: 'Desc. Tipo de Container',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'DestinoFinal',
                text: 'Destino Final',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'LacreArm',
                text: 'Lacre Armador',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'LacreCli',
                text: 'Lacre Cliente',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'LacreSif',
                text: 'Lacre SIF',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'LacreTer',
                text: 'Lacre Terminal',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'PesoNet',
                text: 'Peso Net.',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'Temperatura',
                text: 'Temp.',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'MercadoriaSai',
                text: 'Mercadoria',
                sort: true,
                sortCaret: sortCaret,
                formatter: textFormatter,
                align: () => 'center'
            },
            {
                dataField: 'Presenca',
                text: 'Presença de Carga',
                sort: true,
                sortCaret: sortCaret,
                formatter: YesNoFormatter,
                align: () => 'center'
            },
            {
                dataField: 'DiasNoPatio',
                text: 'Dias Patio',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'PortoSai',
                text: 'Porto de Descarga',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'Posicao',
                text: 'Posição',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'PortoOri',
                text: 'Porto de Embarque',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'IsOog',
                text: 'é Oog.',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'DataSaida',
                text: 'Saída',
                sort: true,
                sortCaret: sortCaret,
                formatter: formatarDataMov,
                align: () => 'center'
            },
            {
                dataField: 'DataEntrada',
                text: 'Entrada',
                sort: true,
                sortCaret: sortCaret,
                formatter: formatarDataMov,
                align: () => 'center'
            },
            {
                dataField: 'OperacaoEnt',
                text: 'Operação de Entrada',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'OperacaoSai',
                text: 'Operação de Saída',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'PesoReal',
                text: 'Peso Bruto',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'PesoDocumental',
                text: 'Peso Doc.',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'RetencaoSrf',
                text: 'Retido Receita',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'Retencao',
                text: 'Retido Siscarga',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'CargaRefri',
                text: 'Reefer',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'OverTime',
                text: 'Periodo de Overtime',
                sort: true,
                sortCaret: sortCaret,
                formatter: YesNoFormatter,
                align: () => 'center'
            },
            {
                dataField: 'TaraCntr',
                text: 'Tara',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'DscStatusCntr',
                text: 'Status',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'CargaSobreMedida',
                text: 'Over Dimension',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'NumeroDde',
                text: 'Doc. Exp.',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'Cliente',
                text: 'Cliente',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'

            },
            {
                dataField: 'CnpjCliente',
                text: 'CNPJ Cliente',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'SubCategoria',
                text: 'Subcategoria',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'RestowType',
                text: 'Tipo de Remoção',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            },
            {
                dataField: 'NumNotaTransp',
                text: 'Nota Transporte',
                sort: true,
                sortCaret: sortCaret,
                align: () => 'center'
            }

        ]

        this.colunas = this.todasColunas
        this.camposTabela = []
        this.movimentacaoService = new MovimentacaoService();
        this.carregarCampos()
        this.carregarFiltros();
    }

    setDataInicioTemp = (value) => {
        this.dataInicialTemp = value;
    };

    setDataFimTemp = (value) => {
        this.dataFinalTemp = value;
    };

    setTipoMovimentacao = (value) => {
        this.tipoMovimentacao = value;
        //A pedido do cliente, devemos desabilitar os campos de período e operação se a operação for 'No Pátio'
        if (value !== null && value.value === 'P') {
            this.operacaoAtivo = false
            this.periodoAtivo = false
        } else {
            this.operacaoAtivo = true
            this.periodoAtivo = true
        }
    };

    setStatus = (value) => {
        this.status = value;
    };

    setTipo = (value) => {
        this.tipo = value;
    };

    setTamanho = (value) => {
        this.tamanho = value;
    };

    setCategoria = (value) => {
        this.categoria = value;
    };
    setArmadores = (value) => {
        this.armadores = value;
    };

    setOperacao = (value) => {
        this.operacao = value;
    };

    setCliente = (value) => {
        this.cliente = value;
    };

    setGrupos = (value) => {
        this.grupos = value
    }

    getListaCopia = () => {
        return toJS(this.listaItens)
    }

    getCategorias = () => {
        return toJS(this.listaCategoria)
    }

    alterarPeriodo = () => {
        if (this.dataInicialTemp && this.dataFinalTemp) {
            this.dataInicial = this.dataInicialTemp;
            this.dataFinal = this.dataFinalTemp;
        }
        this.listarOperacoes();
    };

    alternarDataSeletor = () => {
        this.seletorPeriodo = !this.seletorPeriodo;
    };

    listarOperacoes() {
        this.listaOperacoes = [];
        this.loadingOperacoes = true;
        this.movimentacaoService.listarOperacoes(this.dataInicial, this.dataFinal).then(response => {
            if (response.data)
                this.listaOperacoes = response.data
            if (this.listaOperacoes.length === 1) this.operacao = {
                value: this.listaOperacoes[0].Id,
                label: this.listaOperacoes[0].ViagemNavio
            }
            else this.operacao = null
            this.loadingOperacoes = false;
        }).catch(erro => {
            console.log(erro)
            this.loadingOperacoes = false;
        });

    }

    listarArmadores = () => {
        this.listaArmadores = [];
        this.loadingArmadores = true
        this.movimentacaoService.listarArmadores(lscache.get('MembershipuserId')).then(response => {
            response.data.forEach(armador => {
                this.listaArmadores.push({
                    value: armador.ArmId,
                    label: armador.ApelidoArmador
                })

            });
            //if (this.listaArmadores.length === 1) this.armadores = this.listaArmadores[0]
            this.loadingArmadores = false
        }).catch(erro => {
            console.log(erro)
            this.loadingArmadores = false

        });

    };

    listarClientes = () => {
        this.listaClientes = [];
        this.loadingClientes = true
        this.movimentacaoService.listarClientes(lscache.get('MembershipuserId')).then(response => {
            response.data.forEach(cliente => {
                this.listaClientes.push({
                    value: cliente.Cnpj,
                    label: cliente.RazaoSocial
                })
            })
            this.loadingClientes = false
        }).catch(erro => {
            console.log(erro)
            this.loadingClientes = false
        })
    }

    listarGrupos = () => {
        this.listaGrupos = [];
        this.loadingGrupos = true
        this.movimentacaoService.listarGurposClientes().then(response => {
            response.data.forEach(grupo => {
                this.listaGrupos.push({
                    value: grupo.Codigo,
                    label: grupo.Descr
                })
            })
            if (process.env.rig && this.listaGrupos.length <= 3) {
                this.setGrupos(this.listaGrupos)
            }
            this.loadingGrupos = false
        }).catch(erro => {
            console.log(erro)
            this.loadingGrupos = false
        })
    }

    listarTiposMov = () => {
        this.listaTipoMovimentacao = []
        this.movimentacaoService.listaTiposMov().then(response => {
            response.data.forEach(tipo => {
                this.listaTipoMovimentacao.push({
                    value: tipo.Codigo,
                    label: tipo.Descr
                })
            })
            if (this.listaTipoMovimentacao.length === 1) this.tipoMovimentacao = this.listaTipoMovimentacao[0]
        }).catch(error => {
            console.log(error)
        })
    }

    listarStatus = () => {
        this.listaStatus = []
        this.movimentacaoService.listarStatus().then(response => {
            response.data.forEach(tipo => {
                this.listaStatus.push({
                    value: tipo.Codigo,
                    label: tipo.Descr
                })
            })
        }).catch(error => {
            console.log(error)
        })
    }

    listarTiposContainer = () => {
        this.listaTipo = []
        this.movimentacaoService.listarTipoCntr().then(response => {
            response.data.forEach(tipo => {
                this.listaTipo.push({
                    value: tipo.Codigo,
                    label: tipo.Descr
                })
            })
        }).catch(error => {
            console.log(error)
        })
    }

    listarTamanhosContainer = () => {
        this.listaTamanho = []
        this.movimentacaoService.listarTamCntr().then(response => {
            response.data.forEach(tipo => {
                this.listaTamanho.push({
                    value: tipo.Codigo,
                    label: tipo.Descr
                })
            })
        }).catch(error => {
            console.log(error)
        })
    }

    listarCategorias = () => {
        this.listaCategoria = []
        this.movimentacaoService.listarCategorias().then(response => {
            response.data.forEach(tipo => {
                this.listaCategoria.push({
                    value: tipo.Codigo,
                    label: tipo.Descr
                })
            })
            if (this.listaCategoria.length === 1) this.categoria = this.listaCategoria[0]
        }).catch(error => {
            console.log(error)
        })
    }

    carregarFiltros = () => {
        this.listarTiposMov()
        this.listarStatus()
        this.listarTiposContainer()
        this.listarTamanhosContainer()
        this.listarCategorias()

        this.listarArmadores()
        this.listarClientes()
        this.listarOperacoes()
        this.listarGrupos()

        this.status = this.listaStatus
        this.tamanho = this.listaTamanho
        this.tipo = this.listaTipo

    }

    resetaObrigatorios = () => {
        this.obrigatoriosPreenchidos = {
            operacao: true,
            tipoMovimentacao: true,
            armadores: true,
            clientes: true,
            grupos: true,
            geral: true
        }
    }

    verificaFiltrosPerfil = (filtros) => {
        this.resetaObrigatorios()
        //Não pode ser um switch case, pois há uma questão de ordem segundo o cliente sobre existência no array de perfis (este array é dinâmico)
        if (this.perfilUsuario.includes('ARMADOR')) {
            if (!filtros["OperId"] && this.operacaoAtivo) {
                this.obrigatoriosPreenchidos.geral = false
                this.obrigatoriosPreenchidos.operacao = false
            }
            if (!filtros["TipoMoviment"]) {
                this.obrigatoriosPreenchidos.geral = false
                this.obrigatoriosPreenchidos.tipoMovimentacao = false
            }
            if ((!filtros["ListaArmadorId"] || !filtros["ListaArmadorId"].length) && !this.perfilUsuario.includes('ADMINISTRADOR')) {
                this.obrigatoriosPreenchidos.geral = false
                this.obrigatoriosPreenchidos.armadores = false
            }
        } else if (process.env.rig) {
            if (!filtros["OperId"] && this.operacaoAtivo) {
                this.obrigatoriosPreenchidos.geral = false
                this.obrigatoriosPreenchidos.operacao = false
            }
            if (!filtros["TipoMoviment"]) {
                this.obrigatoriosPreenchidos.geral = false
                this.obrigatoriosPreenchidos.tipoMovimentacao = false
            }
            if (!filtros["GrupoIds"] || !filtros["GrupoIds"].length) {
                this.obrigatoriosPreenchidos.geral = false
                this.obrigatoriosPreenchidos.grupos = false
            }
        } else {
            if (!filtros["TipoMoviment"]) {
                this.obrigatoriosPreenchidos.geral = false
                this.obrigatoriosPreenchidos.tipoMovimentacao = false
            }
        }
    }

    // Pode ser passado depois para utils
    extractValues(array, property) {
        if (array) {
            return array.map(elem => elem[property])
        } else {
            return []
        }
    }

    pesquisar = () => {
        this.filtrado = true;
        this.loading = true;
        this.operacoes = []
        this.listaItens = []
        console.log(this.cliente);
        let filtros = {
            "OperId": this.operacao && this.operacaoAtivo ? this.operacao.value : null,
            "TipoMoviment": this.tipoMovimentacao && this.tipoMovimentacao.value,
            "ListaCodigoStatusContainer": this.extractValues(this.status, "value"),
            "ListaCodigoTipoContainer": this.extractValues(this.tipo, "value"),
            "ListaCodigoTamanhoContainer": this.extractValues(this.tamanho, "value"),
            "ListaCodigoCategorias": this.categoria && this.extractValues(this.categoria, "value"),
            "ListaArmadorId": this.armadores && this.extractValues(this.armadores, "value"),
            "ClienteCnpj": this.cliente ? this.cliente.value : null,
            "GrupoIds": this.grupos && this.grupos.length > 0 ? this.extractValues(this.grupos, "value") : null
            //"DataInicial": this.dataInicial,
            //"DataFinal": this.dataFinal
        }

        this.verificaFiltrosPerfil(filtros)

        if (this.obrigatoriosPreenchidos.geral) {
            this.movimentacaoService.pesquisar(filtros).then(response => {
                //Verifica se há dados em ListaDetalheMoviment
                if (response.data.ListaDetalheMoviment === null) {
                    //É inclusa a mensagem de responsta vindo do serviço
                    this.tableMessage = response.data.Mensagem
                    this.loading = false
                    this.filtrado = false
                    return
                }
                this.listaItens = response.data.ListaDetalheMoviment.Data;
                this.total = response.data.ListaDetalheMoviment.Total;
                if (this.listaItens.length === 0) {
                    this.tableMessage = buscaSemResultado
                } else {
                    this.tableMessage = buscaFiltrarVazio
                }
                this.loading = false;
            }).catch(erro => {
                console.log(erro)
                this.loading = false;
            });
        } else {
            this.filtrado = false;
        }
    }

    carregarCampos = () => {
        this.loading = true

        Promise.all([
            this.movimentacaoService.listarFiltros(lscache.get('MembershipuserId')).then(response => {
                if (response.data.length) {
                    const campos = response.data; //.map(elem => JSON.parse(elem.ValorObjeto));

                    if (campos.indexOf(campos.find((elem) => JSON.parse(elem.ValorObjeto).valor === 1)) === -1) {
                        this.filtroSelecionado = 0;
                    } else {
                        this.filtroSelecionado = campos.indexOf(campos.find((elem) => JSON.parse(elem.ValorObjeto).valor === 1));
                    }

                    let camposResponse = JSON.parse(campos[this.filtroSelecionado].ValorObjeto);
                    if (camposResponse.dadosTabela.includes("Cod. Armador")) { // TODO apenas para alteração do padrão anterior remover quando for seguro
                        camposResponse = JSON.parse("{\"valor\":0,\"nome\":\"Padrão\",\"descricao\":\"\",\"dadosTabela\":[\"Container\",\"ArmId\"]}");
                    }

                    if (this.camposTabela.length === 0) {
                        this.camposTabela = camposResponse.dadosTabela;
                    }
                } else {
                    this.camposTabela = this.movimentacaoService.obrigatorioMovimentacao;
                }
                this.aplicarCampos();

            }).catch(error => console.log(error))
        ]).then(() => {
            this.loading = false
        }).catch(err => {
            console.log(err);
            this.loading = false
        })
    };

    aplicarCampos = () => {
        let campos = []
        if (this.camposTabela) {
            this.todasColunas.filter(campo => {
                if (this.camposTabela.indexOf(campo.dataField) !== -1) {
                    campos.push(campo)
                }
            })
        }
        this.colunas = campos
    }

    clickCampos = () => {
        this.mostrarCamposExibicao = true
    }

    fecharPagCampos = (filtroSalvo) => {

        if (filtroSalvo) {
            this.mostrarCamposExibicao = false
            this.camposTabela = filtroSalvo.dadosTabela

            this.aplicarCampos()
            this.carregarCampos()
        }

    }

    fecharSemSalvar = () => {
        this.mostrarCamposExibicao = false
        this.carregarCampos()
    }

    //O formater teve de ser passado para cá, pois a informação dos labels das categorias é dinâmico e pode ser mudado pelo cliente através do serviço
    categoriaFormatter = (cell, row) => {
        const categorias = toJS(this.listaCategoria)

        const categoria = categorias.find(cat => cat.value === cell)

        if (!categoria) {
            return null
        } else {
            return categoria.label
        }
    }


    clientesOptions = async (filtro = null) => {
        this.listaClientes = [];
        this.cliente = null;
        const { data } = await this.movimentacaoService.listarClientes(lscache.get('MembershipuserId'), filtro);
        if (data && data.length > 0) {
            this.listaClientes = data.map(cliente => {
                const label = cliente.RazaoSocial + ((cliente.Cnpj) ? ` (${cliente.Cnpj})` : '');
                return { value: cliente.Cnpj, label };
            });
        }
        return this.listaClientes;
    }

}


// WEBPACK FOOTER //
// ./src/modules/consultas/movimentação/stores/MovimentacaoStore.js